import React from 'react';

export default function Conversion() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#18181B' />
      <g clip-path='url(#clip0_2441_6804)'>
        <path
          d='M16.0597 10.913C16.6899 11.148 17.2506 11.538 17.6902 12.0471C18.1297 12.5562 18.4337 13.168 18.5741 13.8257C18.7146 14.4835 18.6869 15.166 18.4937 15.8102C18.3004 16.4545 17.9479 17.0396 17.4686 17.5114C16.9893 17.9833 16.3988 18.3267 15.7516 18.5098C15.1045 18.693 14.4216 18.71 13.7661 18.5593C13.1106 18.4086 12.5037 18.0951 12.0015 17.6477C11.4993 17.2003 11.1181 16.6335 10.893 15.9997M8.66634 7.99967H9.33301V10.6663M15.1397 13.253L15.6063 13.7263L13.7263 15.6063M13.333 9.33301C13.333 11.5421 11.5421 13.333 9.33301 13.333C7.12387 13.333 5.33301 11.5421 5.33301 9.33301C5.33301 7.12387 7.12387 5.33301 9.33301 5.33301C11.5421 5.33301 13.333 7.12387 13.333 9.33301Z'
          stroke='#A1A1AA'
          stroke-width='1.25'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2441_6804'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(4 4)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
